/*!
 * @Author: luoob
 * @Date: 2021-03-23 14:52:00
 * @Last Modified by: luoob
 * @Last Modified time: 2021-03-23 14:52:00
 * @Introduction: 线索模块路由
 */

const ClueLatest = () => import('@/views/clue/latest.vue')
const ClueDetail = () => import('@/views/clue/detail.vue')
const ChannelList = () => import('@/views/clue/channelList.vue')
const ChannelSort = () => import('@/views/clue/channelSort.vue')
const DataSourceSort = () => import('@/views/clue/dataSourceSort.vue')
const CluePublish = () => import('@/views/clue/publish.vue')
const LevyList = () => import('@/views/clue/levyList.vue')
const LevyDetail = () => import('@/views/clue/levyDetail.vue')
const SourceList = () => import('@/views/clue/sourceList.vue')
const SourceSetting = () => import('@/views/clue/sourceSetting.vue')
const CommentList = () => import('@/views/clue/commentList.vue')
const ClueReported = () => import('@/views/clue/reported.vue')

/* Layout */
import Layout from '@/layout/index.vue'
/* Children Layout */
import ChildLayout from '@/layout/children_layout.vue'

export default {
    path: '/clue',
    component: Layout,
    redirect: '/clue/latest',
    meta: {
        title: '线索',
        icon: 'icon-zhifeiji',
        alwaysShow: true
    },
    children: [
        {
            path: 'reported',
            component: ChildLayout,
            children: [
                {
                    path: '',
                    name: 'ClueReported',
                    component: ClueReported,
                    meta: {
                        title: '已报道线索'
                    }
                }
            ]
        },
        {
            path: 'latest',
            name: 'ClueLatest',
            component: ClueLatest,
            meta: {
                title: '最新线索'
            }
        },
        {
            path: 'comments',
            name: 'Comments',
            component: CommentList,
            meta: {
                title: '评论列表'
            }
        },
        {
            path: 'levy/list',
            name: 'LevyList',
            component: LevyList,
            meta: {
                title: '征集列表'
            }
        },
        {
            path: 'channel/sort',
            name: 'ChannelSort',
            component: ChannelSort,
            meta: {
                title: '线索分类'
            }
        },
        {
            path: 'channel/list',
            name: 'ChannelList',
            component: ChannelList,
            meta: {
                title: '渠道列表'
            }
        },
        {
            path: 'source/sort',
            name: 'DataSourceSort',
            component: DataSourceSort,
            meta: {
                title: '数据源分类'
            }
        },
        {
            path: 'channel/source/:id',
            name: 'SourceList',
            component: SourceList,
            meta: {
                title: '数据源列表',
                hidden: true
            }
        },
        {
            path: 'channel/source/setting/:type',
            name: 'SourceSetting',
            component: SourceSetting,
            meta: {
                title: '设置数据源',
                hidden: true
            }
        },
        {
            path: 'publish',
            name: 'CluePublish',
            component: CluePublish,
            meta: {
                title: '发布线索'
            }
        },
        {
            path: ':id',
            name: 'ClueDetail',
            component: ClueDetail,
            meta: {
                title: '线索详情',
                hidden: true
            }
        },
        {
            path: 'levy/:id',
            name: 'LevyDetail',
            component: LevyDetail,
            meta: {
                title: '征集详情',
                hidden: true
            }
        }
    ]
}
